import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b55c071"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page page-alerts-history page-table" }
const _hoisted_2 = { class: "page-table-body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "alert-information" }
const _hoisted_5 = { class: "table-main hide-sp" }
const _hoisted_6 = { class: "city" }
const _hoisted_7 = { class: "alerts" }
const _hoisted_8 = { class: "alerts" }
const _hoisted_9 = { class: "sp-table-main hide-pc" }
const _hoisted_10 = { class: "city" }
const _hoisted_11 = { class: "alerts" }
const _hoisted_12 = { class: "alerts cancel" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<h4 class=\"legends-sp-title hide-pc\" data-v-5b55c071>凡例</h4><ul class=\"legends flex flex-between mt-2 bc-2\" data-v-5b55c071><li class=\"legend hide-sp\" data-v-5b55c071>凡例</li><li class=\"legend hide-sp\" data-v-5b55c071>｜</li><li class=\"legend special legend-item\" data-v-5b55c071>特別警報</li><li class=\"legend\" data-v-5b55c071>｜</li><li class=\"legend alert legend-item\" data-v-5b55c071>警報</li><li class=\"legend\" data-v-5b55c071>｜</li><li class=\"legend warning legend-item\" data-v-5b55c071>注意報</li><li class=\"legend hide-sp\" data-v-5b55c071>｜</li><li class=\"legend new legend-item\" data-v-5b55c071>発表</li><li class=\"legend\" data-v-5b55c071>｜</li><li class=\"legend cancel legend-item\" data-v-5b55c071>解除</li><li class=\"legend\" data-v-5b55c071>｜</li><li class=\"legend remain legend-item\" data-v-5b55c071>継続</li><li class=\"legend hide-sp\" data-v-5b55c071>｜</li><li class=\"legend cancel-special\" data-v-5b55c071>特別警報 ＞ 警報 or 注意報に変化</li><li class=\"legend hide-sp\" data-v-5b55c071>｜</li><li class=\"legend cancel-alert\" data-v-5b55c071>警報 ＞ 注意報に変化</li></ul>", 2)

import { computed, onMounted } from 'vue'
import moment from 'moment'
import { AlertKind, ALERT_KIND_STATUSES } from '@/models/WeatherWarning'
import SpAlertsLinks from '@/components/alerts/SpAlertsLinks.vue'
import { useWeatherWaringStore } from '@/stores/weatherWarningStore'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const CONDITION_CLASSES = {
  [ALERT_KIND_STATUSES.NEW]: 'new',
  [ALERT_KIND_STATUSES.CANCEL]: 'cancel',
  [ALERT_KIND_STATUSES.CONTINUE]: 'continue',
  [ALERT_KIND_STATUSES.CANCEL_SPECIAL]: 'cancel-special',
  [ALERT_KIND_STATUSES.CANCEL_ALERT]: 'cancel-alert',
}

const initDataStore = useInitDataStore()
const weatherWarningSotre = useWeatherWaringStore()

onMounted(() => {
  const areaList = initDataStore.initData.definitionInfo.alerts?.common?.areaInfo || []

  weatherWarningSotre.fetch(areaList)
})

const data = computed(() => {
  return {
    weatherWarningData: weatherWarningSotre.weatherWarningData,
  }
})

const kindClass = (kind: AlertKind) => {
  const { status, code } = kind
  const conditionClass = CONDITION_CLASSES[status as keyof typeof CONDITION_CLASSES]
  const codeNum = Number(code)
  const typeClass = codeNum <= 8 ? 'alert' : codeNum <= 27 ? 'warning' : 'special'

  return [conditionClass, typeClass]
}

const filterCancelKinds = (kinds: AlertKind[]) => {
  return kinds.filter(kind => kind.status === ALERT_KIND_STATUSES.CANCEL)
}

const filterNotCancelKinds = (kinds: AlertKind[]) => {
  return kinds.filter(kind => kind.status !== ALERT_KIND_STATUSES.CANCEL)
}

const alertInformation = computed(() => {
  const warningData = data.value.weatherWarningData

  if (warningData.length === 0) {
    return ''
  }

  const { updatedAt, publishingOffice } = warningData[0]
  const dateLabel = moment(updatedAt).format('YYYY年MM月DD日 HH時mm分')

  return `${dateLabel} ${publishingOffice}発表`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SpAlertsLinks),
    _createElementVNode("div", _hoisted_2, [
      (_unref(data).weatherWarningData.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "警報は発表されていません。"))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(alertInformation)), 1),
      _createElementVNode("table", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).weatherWarningData, (datum, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", _hoisted_6, _toDisplayString(datum.area.name), 1),
            _createElementVNode("td", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterNotCancelKinds(datum.kinds), (kind, kindIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: kindIndex,
                  class: _normalizeClass([kindClass(kind), "alert-item"])
                }, _toDisplayString(kind.name), 3))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterCancelKinds(datum.kinds), (kind, kindIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: kindIndex,
                  class: _normalizeClass([kindClass(kind), "alert-item"])
                }, _toDisplayString(kind.name), 3))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).weatherWarningData, (datum, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "area-box"
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(datum.area.name), 1),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterNotCancelKinds(datum.kinds), (kind, kindIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: kindIndex,
                  class: _normalizeClass([kindClass(kind), "alert-item"])
                }, _toDisplayString(kind.name), 3))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterCancelKinds(datum.kinds), (kind, kindIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: kindIndex,
                  class: _normalizeClass([kindClass(kind), "alert-item"])
                }, _toDisplayString(kind.name), 3))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _hoisted_13
    ])
  ]))
}
}

})